// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3UQAz","productName":"Table_productName__3O3Sw"};